import {
    GET_GENERAL_CONFIG,
    GET_GENERAL_CONFIG_SUCCESS,
    GET_GENERAL_CONFIG_FAIL,
} from '../../../constants/maintenance/alarmConfigurationConstants/generalConfigConstants.js';

/**
 * Reducer function for managing general alarm configuration state.
 *
 * This reducer handles actions related to fetching general alarm configuration.
 * It updates the state based on the dispatched action type and payload.
 *
 * @param {object} state - Current state of the general alarm configuration.
 * @param {object} action - Action object that contains information about the action type and payload.
 * @return {object} - New state after applying the action.
 */
export const generalConfigReducer = (state = { general: {} }, action) => {
    switch (action.type) {
        case GET_GENERAL_CONFIG:
            return {
                loading: true,
            };
        case GET_GENERAL_CONFIG_SUCCESS:
            return {
                loading: false,
                general: action.payload,
            };
        case GET_GENERAL_CONFIG_FAIL:
            return {
                loading: false,
                error: action.payload,
            };
        default:
            return state;
    }
};
